import { Routes } from '@angular/router';
import { ImportContactsComponent } from './components/admin/import-contacts/import-contacts.component';
import { SettingsComponent } from './components/settings/settings/settings.component';
import { UploadComponent } from './components/admin/upload/upload.component';
import { ContactsComponent } from './components/contacts/contacts/contacts.component';
import { EditContactComponent } from './components/contacts/edit-contact/edit-contact.component';
import { EditEventComponent } from './components/events/edit-event/edit-event.component';
import { EventsComponent } from './components/events/events/events.component';
import { AccessDeniedComponent } from './components/misc/access-denied/access-denied.component';
import { ErrorComponent } from './components/misc/error/error.component';
import { WelcomePageComponent } from './components/misc/welcome-page/welcome-page.component';
import { EditOrganisationComponent } from './components/organisations/edit-organisation/edit-organisation.component';
import { OrganisationsComponent } from './components/organisations/organisations/organisations.component';
import { EditProjectComponent } from './components/projects/edit-project/edit-project.component';
import { ProjectsComponent } from './components/projects/projects/projects.component';
import { SuppliersComponent } from './components/suppliers/suppliers/suppliers.component';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';
import { ROLES } from './services/o365-auth.service';
import { FlatRefDataComponent } from './components/settings/flat-ref-data/flat-ref-data.component';
import { HierarchicalRefDataComponent } from './components/settings/hierarchical-ref-data/hierarchical-ref-data.component';

export const routes: Routes = [
    {
        path: 'welcome',
        component: WelcomePageComponent
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: '',
        canActivate: [authGuard, roleGuard([ROLES.REGULAR])],
        children: [
            {
                path: 'home',
                component: WelcomePageComponent,
                data: { breadcrumb: 'Home' },
            },
            {
                path: "suppliers",
                component: SuppliersComponent,
                data: { breadcrumb: 'Suppliers' },
            },
            {
                path: "contacts",
                component: ContactsComponent,
                data: { breadcrumb: 'Contacts' },
            },
            {
                path: "contacts/new",
                component: EditContactComponent,
                data: { breadcrumb: 'New Contact' },
            },
            {
                path: "contacts/:id",
                component: EditContactComponent,
                data: { breadcrumb: 'Contact Details' },
            },
            {
                path: "organisations",
                component: OrganisationsComponent,
                data: { breadcrumb: 'Organisations' },
            },
            {
                path: "organisations/new",
                component: EditOrganisationComponent,
                data: { breadcrumb: 'New Organisation' },
            },
            {
                path: "organisations/:id",
                component: EditOrganisationComponent,
                data: { breadcrumb: 'Organisation Details' },
            },
            {
                path: "projects",
                component: ProjectsComponent,
                data: { breadcrumb: 'Projects' },

            },
            {
                path: 'projects/new',
                component: EditProjectComponent,
                data: { breadcrumb: 'New Project' },
            },
            {
                path: 'projects/:id',
                component: EditProjectComponent,
                data: { breadcrumb: 'Project Details' },
            },
            {
                path: "events",
                component: EventsComponent,
                data: { breadcrumb: 'Events' },
            },
            {
                path: 'events/new',
                component: EditEventComponent,
                data: { breadcrumb: 'New Event' },
            },
            {
                path: 'events/:id',
                component: EditEventComponent,
                data: { breadcrumb: 'Event Details' },
            },
            {
                path: 'upload',
                component: UploadComponent,
                // canActivate: [roleGuard([ROLES.ADMIN])],
                data: { breadcrumb: 'Import' },
            },
            {
                path: 'import',
                component: ImportContactsComponent,
                // canActivate: [roleGuard([ROLES.ADMIN])],
                data: { breadcrumb: 'Import' },
            },
            {
                path: 'import/:id',
                component: ImportContactsComponent,
                // canActivate: [roleGuard([ROLES.ADMIN])],
                data: { breadcrumb: 'Import' },
            },
            {
                path: 'settings',
                component: SettingsComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { breadcrumb: 'Settings' },
            },
            {
                path: 'settings/initiatives',
                component: FlatRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'initiatives' }
            },
            {
                path: 'settings/eventtypes',
                component: FlatRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'eventTypes' }
            },
            {
                path: 'settings/languages',
                component: FlatRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'languages' }
            },      
            {
                path: 'settings/audiences',
                component: HierarchicalRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'audiences' }
            },            
            {
                path: 'settings/products',
                component: HierarchicalRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'products' }
            },            
            {
                path: 'settings/contactStakeholderGroups',
                component: HierarchicalRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'contactStakeholderGroups' }
            },            
            {
                path: 'settings/orgStakeholderGroups',
                component: HierarchicalRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'orgStakeholderGroups' }
            },          
            {
                path: 'settings/generalTopicsOfInterest',
                component: FlatRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'generalTopicsOfInterest' }
            },            
            {
                path: 'settings/memberTopicsOfInterest',
                component: FlatRefDataComponent,
                canActivate: [roleGuard([ROLES.ADMIN])],
                data: { collection: 'memberTopicsOfInterest' }
            },                  
            {
                path: 'error',
                children: [
                    { path: ':code', component: ErrorComponent },
                    { path: '**', component: ErrorComponent },
                ]
            },
            { path: '**', redirectTo: 'home' },
        ]
    },
];

